(ns common.ui.slide
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [cljs.core.match :as match]
            [clojure.spec.alpha :as spec]
            [common.ui.add-item :as ui.add-item]
            [common.ui.list :refer [delete-item items list-type sequence-list]]
            [common.ui.store :as store]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]))

(spec/def :slide/current #(spec/nilable (satisfies? store/DataDomainEntity %)))
(spec/def :slide/continue-cycle? boolean?)

(spec/def :slide/content (spec/or :from-cfg #{:entity/content :list-item/details}
                                  :custom fn?))

(spec/def :slide/configuration
  (spec/merge :list/configuration
              (spec/keys
               :req [:slide/slide-idx->query-param]
               :opt [:slide/current
                     :slide/content
                     :slide/continue-cycle?])))

(defmulti sequence-nr list-type)

(defmethod sequence-nr :sequence-relation
  [{:keys [position-attribute slide/current]}]
  (dec @(store/get-value current position-attribute)))

(defmethod sequence-nr :default
  [{:slide/keys [current] :as cfg}]
  (some (fn [[idx item]]
          (when (= item (:eid current))
            (dec idx)))
        (items cfg)))

(defn link
  [current-slide slide-idx->query-param slide-idx]
  (when-let [query-param (:entity/query-param current-slide)]
    @(rf/subscribe
      [:entity/link (merge @(rf/subscribe query-param)
                           (slide-idx->query-param slide-idx))])))

(defn view [{:list/keys [->item-cfg add-item-cfg allow-delete-items?]
             :slide/keys [continue-cycle? current slide-idx->query-param content]
             :or {content :entity/content}
             :as cfg}]
  {:pre [(spec/assert :slide/configuration cfg)]}
  (let [cfg (sequence-list cfg)
        slides (items cfg)
        total-slides (count slides)
        has-slides? (pos? total-slides)
        has-one-slide? (= total-slides 1)
        current-slide-idx (when current (sequence-nr cfg))
        current-slide (some-> current ->item-cfg)
        current-is-first-slide? (zero? current-slide-idx)
        current-is-last-slide? (= (inc current-slide-idx) total-slides)
        allow-delete-slide? (and allow-delete-items? (not (:entity/read-only? cfg)) (:entity/ref current-slide))]
    (cond-> [:> Stack {:sx #js {:overflow "hidden"}}]
      (and has-slides? current-slide)
      (conj [:> Stack {:direction "row"
                       :flex-grow 1
                       :justify-content "space-between"
                       :align-items "center"
                       :px 3
                       :py 1
                       :background-color "grey.90"}
             [:> Button {:startIcon ($ Icon "keyboard_arrow_left")
                         :data-testid "slide-item-previous"
                         :disabled (or has-one-slide?
                                       (and (not continue-cycle?)  current-is-first-slide?))
                         :href (link current-slide slide-idx->query-param
                                     (if current-is-first-slide?
                                       (if continue-cycle? (dec total-slides) current-slide-idx)
                                       (dec current-slide-idx)))} "Previous"]
             [:> Typography {:fontWeight 600} (inc current-slide-idx) " / " (str total-slides)]
             [:> Button {:endIcon ($ Icon "keyboard_arrow_right")
                         :data-testid "slide-item-next"
                         :disabled (or has-one-slide?
                                       (and (not continue-cycle?) current-is-last-slide?))
                         :href (link current-slide slide-idx->query-param
                                     (if current-is-last-slide?
                                       (if continue-cycle? 0 current-slide-idx)
                                       (inc current-slide-idx)))} "Next"]])

      (some? add-item-cfg)
      (conj
       [:> Stack {:direction "row"
                  :flex-grow 1
                  :justify-content "space-between"
                  :align-items "center"
                  :px 3
                  :py 1}
        ($ ui.add-item/view add-item-cfg)
        (when allow-delete-slide?
          [:> IconButton {:href (link current-slide slide-idx->query-param
                                      (max 0 (dec current-slide-idx)))
                          :on-click #(delete-item cfg (:entity/ref current-slide))}
           [:> Icon "delete"]])])

      current-slide
      (conj
       (match/match
        (spec/conform :slide/content content)
         [:from-cfg cfg-key] (cfg-key current-slide)
         [:custom reagent-fn] [reagent-fn current])))))
